var React = require('react');

function Location (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#01104b","d":"M15.9,3a8.394,8.394,0,0,0-8.4,8.4c0,6.3,8.4,15.6,8.4,15.6s8.4-9.3,8.4-15.6A8.394,8.394,0,0,0,15.9,3Zm0,11.4a3,3,0,1,1,3-3A3,3,0,0,1,15.9,14.4Z","transform":"translate(-3.5 -3)","key":0}),React.createElement("rect",{"fill":"none","width":"24","height":"24","key":1})]);
}

Location.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Location;

Location.default = Location;
